<template>
  <div class="content-main">

    <div class="shanzha">

      <div class="logo-and-wish flex-box">
        <img class="logo" :src="$store.state.favicon">
        <span>{{$store.state.siteSlogan}}</span>
      </div>

      <div class="postcard-rule-v2 flex-box" @click="goPostcardExample()">
        <!-- <span class="rule-dot">•</span> -->
        <span class="gesture-right">👉</span><span class="rule-text">点此免费寄出纸质明信片</span>
        <!-- <span class="gesture-right">👉</span><span class="rule-text">点击查看纸质信实拍图</span> -->
        <!-- <span class="gesture-right">👉</span><span class="rule-text">我们谈一场3天就分手的恋爱吧</span> -->
      </div>

      <div class="infos">
        <van-list
          class = "infos-list"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了~"
          @load="onLoad">

          <div class="info-item" v-for="info in infos" :key="info.id">
            <div class="userinfo flex-box">
              <div class="headimg-nickname flex-box">
                <img class="headimg" :src="info.headimgurl">
                <div class="nickname">{{info.nickname}}</div>
              </div>
              <div class="date">写信日期：{{info.create_date}}</div>
            </div>
            <div class="info-content">To: {{info.receiver}}</div>
            <div class="info-content" style="white-space: pre-wrap;text-indent:1em;margin-top:5px;margin-bottom:5px;">{{info.content}}</div>
            <div class="send-date-and-sender flex-box">
              <!-- <div class="date">寄信时间：{{info.send_date}}</div> -->
              <div v-if="info.own == 2" class="info-content" style="text-align:right;">From: {{info.sender}}</div>
              <div v-if="info.own == 1" class="box-more flex-box" @click="showFeedbackAction(info.id)"><van-icon name="ellipsis" /></div>
            </div>
          </div>

        </van-list>
      </div>

    </div>

    <div class="btn-check flex-box" @click="goMailCreate()"><div class="btn-txt flex-box"><div>开始</div><div>写信</div></div></div>

    <van-tabbar v-model="tabActive" active-color="#b17e94">
      <van-tabbar-item icon="wap-home">广场</van-tabbar-item>
      <van-tabbar-item icon="envelop-o" @click="goMailCreate()">写信</van-tabbar-item>
      <van-tabbar-item icon="manager-o" @click="goUserCenter()">个人中心</van-tabbar-item>
    </van-tabbar>

    <van-popup class="feedback-popup" v-model="showFeedbackPopup" position="bottom">
      <!-- <div class="title">留言内容：「 {{ feedbackPopTitle }}... 」</div> -->
      <div class="feedback-entries">
        <div class="item flex-box entry-shield" @click="removeFromSquare()"><van-icon name="delete" />移出广场</div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import { Toast, List, Popup, Tabbar, TabbarItem, Icon } from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [List.name]: List,
    [Popup.name]: Popup,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Icon.name]: Icon
  },
  data(){
    return {
      infos: [],
      next_page: 1,
      total_entries: 1,
      total_pages: 1,
      finished: false,
      loading: false,
      published: false,
      mailOptionsPopup: false,
      checkMailWechat: false,
      checkMailPostcard: false,
      pickedMailOptions: [],
      tabActive: 0,
      showFeedbackPopup: false,
      feedbackInfoId: ''
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    onLoad() {
      this.loading = true
      this.getMsgs()
    },
    getMsgs(){
      let openid = this.$store.state.userinfo.openid
      this.$api.get('/momentbox/get_mails_for_square', {page: this.next_page, openid: openid}, res => {
        if(res.code == 200 && res.infos){
          this.infos = this.infos.concat(res.infos)
          this.total_entries = res.paginate.total_entries
          this.next_page = this.next_page + 1
          this.total_pages = res.paginate.total_pages
          if(this.next_page > this.total_pages){
            this.finished = true
          }
        }
        this.loading = false
      })
    },
    goHome(){
      this.$router.replace("/?referal=" + this.$store.state.referal)
    },
    goMailCreate(){
      this.$router.replace("/mail_create?referal=" + this.$store.state.referal)
    },
    goUserCenter(){
      this.$router.replace("/mails_records?referal=" + this.$store.state.referal)
    },
    goPostcardRule(){
      window.location.href = ""
    },
    setReferal(){
      let searchParams = new URLSearchParams(window.location.search)
      if(searchParams.get("referal")){
        this.$store.commit('setReferal', { referal: searchParams.get("referal") })
      }
    },
    goPostcardExample(){
      // window.location.href = "https://mp.weixin.qq.com/s/QR69Ds0YQUR5TaRBL7pS2Q"
      // window.location.href = "https://mp.weixin.qq.com/s/KIXZPA9Lak1l404A4QA31w"
      window.location.href = "https://mp.weixin.qq.com/s/HKzPQbCDWXcA1MDt_D28CA"
    },
    showFeedbackAction(id){
      this.feedbackInfoId = id
      this.showFeedbackPopup = true
    },
    removeFromSquare(){
      let id = this.feedbackInfoId
      let openid = this.$store.state.userinfo.openid
      this.$api.post('/momentbox/remove_from_square_by_user', {info_id: id, openid: openid}, res => {
        if(res.code == 200){
          Toast('移出成功！')
          this.infos = []
          this.total_entries = 1
          this.next_page = 1
          this.total_pages = 1
          this.getMsgs()
        }
        this.showFeedbackPopup = false
      })
    }
  },
  mounted(){
    this.setReferal()
  }
}
</script>

<style scoped>
.content-main{min-height:100vh;background-color: #f8f8f8;color:#b17e94;}
.shanzha{padding:20px;}
.logo-and-wish{padding:15px 0px;font-size:30px;margin-bottom:20px;}
.logo{height:150px;width:150px;border-radius:150px;margin-right:35px;}
.btn-check{
  width:120px;height:120px;border-radius:120px;background:#b17e94;position:fixed;
  bottom:150px;right:40px;color:#fff;justify-content:center;
}
.btn-txt{
  flex-direction: column;justify-content:center;width:102px;height:102px;border:2px solid #fff;
  border-radius:102px;font-size:25px;
}
.postcard-rule-v2{background:#fff;margin-bottom:20px;height:100px;padding-left:20px;justify-content: flex-start;}
.postcard-rule-v2 .gesture-right{font-size:36px;margin-right:10px;}
.postcard-rule-v2 .rule-dot{color:#f39c12;margin-right:10px;font-size:60px;padding-bottom:10px;}
.postcard-rule-v2 .rule-text{color:#333;font-size:28px;font-weight:bold;}
.infos{background:#f8f8f8;text-align:left;color:#b17e94;}
.infos .info-item{
  padding:20px;color:#a0a0a0;margin-bottom:20px;background:#fff;border-radius:15px;
  box-shadow:0px 2px 6px rgba(0,0,0,0.15);
}
.infos .userinfo{font-size:28px;justify-content:space-between;align-items:center;margin-bottom:20px;}
.infos .userinfo .date{font-size:24px;}
.infos .nickname{color:#333;}
.infos .headimg{width:50px;height:50px;border-radius:50px;margin-right:20px;}
.infos .info-content{font-size:28px;color:#666;}
/* .infos .send-date-and-sender{justify-content:space-between;} */
.infos .send-date-and-sender{justify-content: flex-end;}
.infos .send-date-and-sender .date{font-size:24px;}
.infos .send-date-and-sender .box-more{font-size:40px;color:#666;}

.pop-mailway{font-size:32px;padding:20px;color:#737373;font-weight:normal;}
.pop-mailway .payway-title{margin-bottom:25px;}
.pop-mailway .price-item{
  background:#f7f9fc;margin-bottom:25px;padding:25px 20px;color:#737373;font-size:28px;
  justify-content:space-between;border-radius:10px;border:4px solid #f7f7f7;
}
.pop-mailway .price-item .icon-check{width:45px;height:45px;}
.pop-mailway .tag{font-size:20px;margin-left:15px;background:#fff;color:#8d8b8b;padding:2px 8px;border-radius:10px;border:2px solid #c0bebe;}
.pop-mailway .price-remark{font-size:20px;text-align:left;padding-right:20px;margin-top:10px;}
.pop-mailway .pay-confirm{background:#b17e94;color:#fbfbfb;padding:20px;border-radius:10px;}

.feedback-popup{background:#fff;color:#333;font-size:10px;}
.feedback-popup .title{border-bottom:1px solid #f0f0f0;text-align:left;padding:10px;color:#666;}
.feedback-popup .feedback-entries{padding:0px 30px;}
.feedback-popup .item{padding:30px 15px;font-size:28px;justify-content:center;align-items:center;}
.feedback-popup .item .van-icon{margin-right:20px;font-size:28px;font-weight:bold;color:#666;}
.feedback-popup .item.entry-shield{border-top:1px solid #f0f0f0;}
</style>
